module.exports = __webpack_public_path__ + "img/c00_buildingtechshippinglanes_Normal_ua.748bd57c.webp";